App.factory('a2pTelnyxBrand', ['restmod', '$api', (restmod, $api) => {
  return restmod.model().mix({
    $extend: {
      Model: {
        $find: function(params = {}) {
          return $api('GET', `/telephony/a2p/telnyx/brand`, params);
        },
        $save: function(data) {
          const method = data.editing ? 'PUT' : 'POST';
          return $api(method, `/telephony/a2p/telnyx/brand`, {}, data);
        },
      }
    }
  })
}])
